// La configuración puede cargarse de dos formas:
// - En desarrollo, index.html incluye config.js, que define la variable global config.
// - En producción, config.js no se carga y la configuración se obtiene mediante
//   fetch desde /solar/config.json.
//
// Si`config ya existe, inicializamos directamente la aplicación.
// En caso contrario, cargamos primero el JSON de configuración.
var visor2D = undefined;
var visor3D = undefined;
var map_dimensions_toggle = undefined;
var default_config = undefined;
var selection_plugin = undefined;
var filterSlider = new FilterSlider();
var opacitySlider = new OpacitySlider();
// var config = undefined;
//console.log("configContent", config);

document.addEventListener("DOMContentLoaded", function () {
    // Si la config no se ha cargado (modo pro)
    if (typeof config === "undefined") {
        // Producción: cargar config.json
        fetch('/solar/config.json')
            .then(response => response.json())
            .then(c => {
                config = c;
                initApp();
            })
            .catch(e => console.error("Error loading config:", e));
    } else {
        // Desarrollo: config.js ya definió config
        initApp();
    }

});

function initApp() {

    document.getElementById("superset-link").href = config.superset.url;

    visor2D = new Visor2D();
    visor3D = new Visor3D();
    map_dimensions_toggle = new MapDimensionsToggler();
    default_config = new DefaultConfig();

    selection_plugin = new SelectionPlugin();
    filterSlider = new FilterSlider();
    opacitySlider = new OpacitySlider();

}